import { PureComponent } from 'react';
import mapProps from 'map-props';
import PropTypes from 'prop-types';
import formValues from 'helpers/form/formValues';
import { SelectControl } from 'components/forms/Select';
import { YEAR_RANGE_NAME } from 'components/searchAds/constants';
import { MIN, MAX } from 'helpers/fieldOptions';

import propsMapping from '../propsMapping';

class YearControl extends PureComponent {
  static propTypes = {
    rangeType: PropTypes.oneOf([MIN, MAX]),
  };

  render() {
    return <SelectControl {...this.props} />;
  }
}

export default formValues({ value: YEAR_RANGE_NAME })(
  mapProps(propsMapping)(YearControl),
);
